/* Gentle Beauty — journal listing: progressive "load more" + active topic pill scroll. Loaded with defer. */
(function () {
  'use strict';

  function fetchDoc(url, sectionId) {
    if (window.GB && typeof window.GB.fetchSection === 'function') return window.GB.fetchSection(url, sectionId);
    var u = new URL(url, window.location.origin);
    u.searchParams.set('section_id', sectionId);
    return fetch(u.toString(), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
  }

  function initLoadMore(root) {
    var more = root.querySelector('[data-gb-blog-more]');
    var grid = root.querySelector('[data-gb-blog-grid]');
    if (!more || !grid || more.hasAttribute('data-init')) return;
    more.setAttribute('data-init', '');
    var sectionId = root.getAttribute('data-section-id');

    more.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-gb-blog-more-btn]');
      if (!btn || btn.classList.contains('is-loading')) return;
      e.preventDefault();
      var url = btn.getAttribute('href');
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');

      fetchDoc(url, sectionId).then(function (doc) {
        var newGrid = doc.querySelector('[data-gb-blog-grid]');
        var cards = newGrid ? Array.prototype.slice.call(newGrid.querySelectorAll(':scope > .gb-bcard')) : [];
        var existing = grid.querySelectorAll('.gb-bcard').length;
        var firstNew = null;
        cards.forEach(function (card, i) {
          card.style.setProperty('--gb-delay', i % 3);
          var node = document.importNode(card, true);
          grid.appendChild(node);
          if (!firstNew) firstNew = node;
        });

        var newMore = doc.querySelector('[data-gb-blog-more]');
        var newBtn = newMore && newMore.querySelector('[data-gb-blog-more-btn]');
        var status = more.querySelector('[data-gb-blog-status]');
        var newStatus = newMore && newMore.querySelector('[data-gb-blog-status]');
        if (status && newStatus) status.textContent = newStatus.textContent;
        var bar = more.querySelector('[data-gb-blog-progress]');
        var newBar = newMore && newMore.querySelector('[data-gb-blog-progress]');
        if (bar && newBar) bar.style.width = newBar.style.width;

        if (newBtn) {
          btn.setAttribute('href', newBtn.getAttribute('href'));
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
        } else {
          btn.remove();
        }

        var live = more.querySelector('[data-gb-blog-live]');
        if (live) live.textContent = live.getAttribute('data-loaded') || '';

        if (window.history && history.replaceState) {
          var clean = new URL(url, window.location.origin);
          clean.searchParams.delete('section_id');
          history.replaceState({}, '', clean.pathname + clean.search);
        }

        if (window.GB && typeof window.GB.init === 'function') window.GB.init(grid);
        if (window.GB && window.GB.pages) window.GB.pages.init(grid);

        if (firstNew) {
          var link = firstNew.querySelector('.gb-bcard__title a');
          if (link) link.focus({ preventScroll: true });
        }
        if (!cards.length && existing) btn && btn.remove();
      }).catch(function () {
        window.location.href = url;
      });
    });
  }

  function initTags(root) {
    var list = root.querySelector('[data-gb-blog-tags]');
    if (!list) return;
    var active = list.querySelector('.is-active');
    if (!active || list.scrollWidth <= list.clientWidth) return;
    var left = active.offsetLeft - (list.clientWidth - active.offsetWidth) / 2;
    list.scrollLeft = Math.max(0, left);
  }

  function init(scope) {
    Array.prototype.slice.call((scope || document).querySelectorAll('[data-gb-blog]')).forEach(function (root) {
      initLoadMore(root);
      initTags(root);
    });
    if (scope && scope.matches && scope.matches('[data-gb-blog]')) { initLoadMore(scope); initTags(scope); }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
